// extracted by mini-css-extract-plugin
export default {"invoiceRequestForm":"ec8d9728149d","firstHeading":"bb59772f65e6"};